import { updateRatesZoneRequest } from "../../data/ratesZoneApi";
import { validateTarifaZonePayload } from "../validator/validateTarifaZonePayload";

export async function updateTarifaZoneUseCase(payload) {
  if (!payload?.id) {
    throw new Error("El id de la tarifa de zona es obligatorio.");
  }

  const error = validateTarifaZonePayload(payload);

  if (error) {
    throw new Error(error);
  }

  return await updateRatesZoneRequest(payload);
}
